import * as React from "react";
import Box from "@mui/joy/Box";
import IconButton from "@mui/joy/IconButton";
import Drawer from "@mui/joy/Drawer";
import List from "@mui/joy/List";
import ListItemButton from "@mui/joy/ListItemButton";
import Typography from "@mui/joy/Typography";
import ModalClose from "@mui/joy/ModalClose";
import Menu from "@mui/icons-material/Menu";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";

export default function DrawerMobileNavigation() {
  const [open, setOpen] = React.useState(false);
  const { t, i18n } = useTranslation(); // Import translation functions
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  return (
    <React.Fragment>
      <IconButton
        size="sm"
        sx={{ color: "#fff", display: { lg: "none" } }}
        onClick={() => setOpen(true)}
      >
        <Menu />
      </IconButton>
      <Drawer open={open} onClose={() => setOpen(false)}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 0.5,
            ml: "auto",
            mt: 1,
            mr: 2,
          }}
        >
          <Typography
            component="label"
            htmlFor="close-icon"
            sx={{ fontSize: "sm", fontWeight: "lg", cursor: "pointer" }}
          >
            {t("close")}
          </Typography>
          <ModalClose id="close-icon" sx={{ position: "initial" }} />
        </Box>
        <List
          size="lg"
          component="nav"
          sx={{
            flex: "none",
            fontSize: "xl",
            "& > div": { justifyContent: "center" },
          }}
        >
          <ListItemButton
            sx={{ fontWeight: "lg", justifyContent: "center" }}
            component={Link}
            to="/"
          >
            {t("home")}
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/services"
            sx={{ justifyContent: "center" }}
          >
            {t("services")}
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/portfolio"
            sx={{ justifyContent: "center" }}
          >
            {t("portfolio")}
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/contact"
            sx={{ justifyContent: "center" }}
          >
            {t("contact")}
          </ListItemButton>
          <ListItemButton
            component={Link}
            to="/rate-us"
            sx={{ justifyContent: "center" }}
          >
            {t("rateUsTitle")}
          </ListItemButton>
          <ListItemButton component={Link} sx={{ justifyContent: "center" }}>
            <Button
              onClick={() => changeLanguage("en")}
              className="langButton"
              style={{ backgroundColor: "black" }}
            >
              English
            </Button>
            <Button
              onClick={() => changeLanguage("ar")}
              className="langButton"
              style={{ backgroundColor: "black" }}
            >
              العربية
            </Button>
          </ListItemButton>
        </List>
      </Drawer>
    </React.Fragment>
  );
}
